import { render, staticRenderFns } from "./TheModals.vue?vue&type=template&id=a475e6ba"
import script from "./TheModals.vue?vue&type=script&lang=js"
export * from "./TheModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports